import type { CustomJsonComponentConfig } from '@apps/websiteCustomJsonComponents/config';
import { createLazyComponentFromNamedExport } from '@shared/utils/createLazyComponent';
import { GeneralScheduleGrabber } from './components/GeneralScheduleSidebar';

// Lazy load view components
const GeneralScheduleAdd = createLazyComponentFromNamedExport(
  () => import(/* webpackChunkName: "content/websiteEditorGeneralScheduleAdd" */ './components/GeneralScheduleSidebar'),
  'GeneralScheduleAdd',
);

const GeneralScheduleEdit = createLazyComponentFromNamedExport(
  () => import(/* webpackChunkName: "content/websiteEditorGeneralScheduleEdit" */ './components/GeneralScheduleEdit'),
  'GeneralScheduleEdit',
);

const GeneralScheduleGuest = createLazyComponentFromNamedExport(
  () => import(/* webpackChunkName: "content/websiteEditorGeneralScheduleGuest" */ './components/GeneralScheduleGuest'),
  'GeneralScheduleGuest',
);

// Add this object to CUSTOM_JSON_COMPONENT_TYPES in
// src/apps/websiteCustomJsonComponents/config.ts
export const GeneralScheduleConfig: CustomJsonComponentConfig = {
  // Tip:
  // Replace this with the URL for the JSONSchema your component data uses.
  // This makes sure PageComponents with this schema will render your components.
  schemaUrl: 'https://withjoy.com/assets/public/schemas/scheduleschema.json',
  componentType: 'GeneralSchedule',
  adminSidebarComponent: {
    addComponentView: GeneralScheduleAdd,
    dragComponentView: GeneralScheduleGrabber,
    editComponentView: GeneralScheduleEdit,
    createComponentView: GeneralScheduleEdit,
  },
  guestSiteComponent: GeneralScheduleGuest,
};
